import getHostFlags from "../../utils/getHostFlags";
import ReportTypeFields from "./ReportTypeFields";

const { isAmazon, isDevOrRoovee } = getHostFlags();

export const ReportDefaultTypes = {
  seasonReport: ReportTypeFields.seasonReport,
  monthlyReport: ReportTypeFields.monthlyReport,
  dayByDayAccountingReport: ReportTypeFields.dayByDayAccountingReport,
  rentalByRentalAccountingReport:
    ReportTypeFields.rentalByRentalAccountingReport,
  monthlyAccountingReport: ReportTypeFields.monthlyAccountingReport,
  userFundsAvailableToWithdraw: ReportTypeFields.userFundsAvailableToWithdraw,
  specialDepositWithdrawalReport:
    ReportTypeFields.specialDepositWithdrawalReport,
  userBikeLeftInZoneBonusReport: ReportTypeFields.userBikeLeftInZoneBonusReport,
  complaintsReport: ReportTypeFields.complaintsReport,
  ridersReport: ReportTypeFields.ridersReport,
  serviceSummaryReport: ReportTypeFields.serviceSummaryReport,
  bikesInSystemReport: ReportTypeFields.bikesInSystemReport,
  monthlyBikesReport: ReportTypeFields.monthlyBikesReport,
  yearlyBikesReport: ReportTypeFields.yearlyBikesReport,
  stationPopularityReport: ReportTypeFields.stationPopularityReport,
  hourlyRentalsReport: ReportTypeFields.hourlyRentalsReport,
  hourlyRentalDurationReport: ReportTypeFields.hourlyRentalDurationReport,
  stationConnectionsReport: ReportTypeFields.stationConnectionsReport,
  bikeDefectsReport: ReportTypeFields.bikeDefectsReport,
  rentalDurationByTypeReport: ReportTypeFields.rentalDurationByTypeReport,
  dailyReport: ReportTypeFields.dailyReport,

  ...(isAmazon
    ? {
        specialReport1: ReportTypeFields.specialReport1,
      }
    : {}),
};

export const ReportTypesForOperatorRooveeDialog = {
  debtCollectionReport: ReportTypeFields.debtCollectionReport,
  totalDistanceByUserReport: ReportTypeFields.totalDistanceByUserReport,
  adjustmentReport: ReportTypeFields.adjustmentReport,
  serviceSummaryReport: ReportTypeFields.serviceSummaryReport,

  ...(isDevOrRoovee
    ? {
        specialGlobalReport: ReportTypeFields.specialGlobalReport,
        specialMonthlyAccountingReport:
          ReportTypeFields.specialMonthlyAccountingReport,
        specialGlobalReportUserDebit:
          ReportTypeFields.specialGlobalReportUserDebit,
        globalUserAvailableFundsDepositReport:
          ReportTypeFields.globalUserAvailableFundsDepositReport,
        tenantUserDebitReport: ReportTypeFields.tenantUserDebitReportPerTenant,
        sportCardExpiredAmount: ReportTypeFields.sportCardExpiredAmount,
        medicoverStatisticReport: ReportTypeFields.medicoverStatisticReport,
        medicoverWithdrawalReport: ReportTypeFields.medicoverWithdrawalReport,
      }
    : {
        tenantUserDebitReport: ReportTypeFields.tenantUserDebitReportDefault,
      }),
};

export const ReportTypesForOperatorAdministratorRooveeDialog = {
  clientFundsReport: ReportTypeFields.clientFundsReport,
  debtCollectionReport: ReportTypeFields.debtCollectionReport,
  totalDistanceByUserReport: ReportTypeFields.totalDistanceByUserReport,
  adjustmentReport: ReportTypeFields.adjustmentReport,
  serviceSummaryReport: ReportTypeFields.serviceSummaryReport,
  braMonthlyAccountingReport: ReportTypeFields.braMonthlyAccountingReport,
  braPeriodicFinancialReport: ReportTypeFields.braPeriodicFinancialReport,
  ...(isDevOrRoovee
    ? {
        specialGlobalReport: ReportTypeFields.specialGlobalReport,
        specialMonthlyAccountingReport:
          ReportTypeFields.specialMonthlyAccountingReport,
        specialGlobalReportUserDebit:
          ReportTypeFields.specialGlobalReportUserDebit,
        globalUserAvailableFundsDepositReport:
          ReportTypeFields.globalUserAvailableFundsDepositReport,
        tenantUserDebitReport: ReportTypeFields.tenantUserDebitReportPerTenant,
        sportCardExpiredAmount: ReportTypeFields.sportCardExpiredAmount,
        medicoverStatisticReport: ReportTypeFields.medicoverStatisticReport,
        medicoverWithdrawalReport: ReportTypeFields.medicoverWithdrawalReport,
        globalDebtCollectionReport: ReportTypeFields.globalDebtCollectionReport,
      }
    : {
        tenantUserDebitReport: ReportTypeFields.tenantUserDebitReportDefault,
      }),
};

export const ReportTypesForClientDialog = {
  seasonReport: ReportTypeFields.seasonReport,
  monthlyReport: ReportTypeFields.monthlyReport,
  dayByDayAccountingReport: ReportTypeFields.dayByDayAccountingReport,
  rentalByRentalAccountingReport:
    ReportTypeFields.rentalByRentalAccountingReport,
  monthlyAccountingReport: ReportTypeFields.monthlyAccountingReport,
  bikesInSystemReport: ReportTypeFields.bikesInSystemReport,
  monthlyBikesReport: ReportTypeFields.monthlyBikesReport,
  yearlyBikesReport: ReportTypeFields.yearlyBikesReport,
  stationPopularityReport: ReportTypeFields.stationPopularityReport,
  hourlyRentalsReport: ReportTypeFields.hourlyRentalsReport,
  hourlyRentalDurationReport: ReportTypeFields.hourlyRentalDurationReport,
  stationConnectionsReport: ReportTypeFields.stationConnectionsReport,
  bikeDefectsReport: ReportTypeFields.bikeDefectsReport,
  rentalDurationByTypeReport: ReportTypeFields.rentalDurationByTypeReport,
  dailyReport: ReportTypeFields.dailyReport,

  ...(isAmazon
    ? {
        specialReport1: ReportTypeFields.specialReport1,
      }
    : {}),
};
